import { GlobalStatus, IsPreparedMaterial, PlantsEnum, TransferMethodEnum, TransferStatusEnum, WorkStationTypeEnum } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { TransferItems } from "./transfer-items.entity";

@Entity('transfer_material')
export class TransferInfo {
    @PrimaryGeneratedColumn("increment", { name: 'transfer_id' })
    packingStockTransferId: number;

    @Column("int", {
        nullable: false,
        name: "unit_id",
    })
    unitId: number;


    @Column("int", {
        nullable: false,
        name: "from_plant"
    })
    fromPlant: number;

    @Column("int", {
        nullable: false,
        name: "to_plant"
    })
    toPlant: number;

    @Column({
        nullable: false,
        name: "transfer_date"
    })
    transferredDate: Date;

    @Column({
        nullable: true,
        name: "received_date"
    })
    receivedDate: Date;

    @Column({
        type: 'enum',
        enum: GlobalStatus,
        nullable: false,
        name: 'transfer_type',
        default: GlobalStatus.NO
    })
    transferType: GlobalStatus;

    @Column({
        type: 'enum',
        enum: TransferMethodEnum,
        nullable: false,
        name: 'transfer_method',
        default: TransferMethodEnum["Plant To Plant"]
    })
    transferMethod: string;

    @Column({
        type: 'enum',
        enum: IsPreparedMaterial,
        nullable: false,
        name: 'is_prepared_material',
        default: IsPreparedMaterial.NO
    })
    isPreparedMaterial: string;

    @Column("varchar", {
        nullable: true,
        length: 60,
        name: "note"
    })
    note: string;

    @Column("varchar", {
        nullable: true,
        name: "dc_number",
        length: 200
    })
    dcNumber: string;

    @Column("varchar", {
        nullable: true,
        name: "mrn_number",
        length: 200
    })
    mrnNumber: string;

    @Column({
        type: 'enum',
        enum: TransferStatusEnum,
        nullable: true,
        default: TransferStatusEnum.IN_TRANSIT,
        name: 'status'
    })
    status: TransferStatusEnum;
    @Column("int", {
        nullable: true,
        default:0,
        name: "sale_order_id",
    })
    saleOrderId: number;
    @Column("int", {
        nullable: true,
        default:0,
        name: "sale_order_item_id",
    })
    saleOrderItemId: number;
    @Column("int", {
        nullable: true,
        name: "indent_id",
    })
    indentId: number;

    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;


    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;


    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "received_user"
    })
    receivedUser: string | null;

    @Column("boolean", {
        nullable: false,
        default: true,
        name: "is_active"
    })
    isActive: boolean | null;

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => TransferItems, trans => trans.poCreationInfo, { cascade: true })
    stockTransferItems: TransferItems[];
}